// libs
import React, { memo } from "react";

// global components
import WithStyles from "shared/components/WithStyles";
import ResponsiveLoader from "shared/components/ResponsiveLoader";

// constants
import { BREAKPOINTS } from "shared/styles/base";
import { TEXTS, FOOTER_LINKS, INSTA_LINK, FB_LINK } from "shared/components/Footer/constants";

// styles
import { lnkCss } from "./styles";

function Links() {
    return (
        <WithStyles cssProps={lnkCss}>
            <div className="lk-content">
                <ResponsiveLoader breakpoint={BREAKPOINTS.TABLET_BIG} up>
                    <div className="lk-section ipad-hide">
                        <div className="lk-title">{TEXTS.WHO_WE_ARE}</div>
                        <ul className="lk-list">
                            <li className="lk-itm">
                                <a className="lk-anc" href={FOOTER_LINKS.ABOUT_US}>
                                    {TEXTS.ABOUT_US}
                                </a>
                            </li>
                            <li className="lk-itm">
                                <a className="lk-anc" href={FOOTER_LINKS.CAREERS}>
                                    {TEXTS.CAREERS}
                                </a>
                            </li>
                            <li className="lk-itm">
                                <a className="lk-anc" href={FOOTER_LINKS.PRESS}>
                                    {TEXTS.PRESS}
                                </a>
                            </li>
                        </ul>
                    </div>
                </ResponsiveLoader>

                <div className="lk-section lk-section-2">
                    <div className="lk-title">{TEXTS.HELP}</div>
                    <ul className="lk-list">
                        <li className="lk-itm">
                            <a className="lk-anc" href={FOOTER_LINKS.CONTACT_US}>
                                {TEXTS.CONTACT_US}
                            </a>
                        </li>
                        <li className="lk-itm">
                            <a className="lk-anc" href={FOOTER_LINKS.SHIPPING}>
                                {TEXTS.SHIPPING}
                            </a>
                        </li>
                        <li className="lk-itm">
                            <a className="lk-anc" href={FOOTER_LINKS.HELP_CENTER}>
                                {TEXTS.HELP_CENTER}
                            </a>
                        </li>
                        <li className="lk-itm">
                            <a className="lk-anc" href={FOOTER_LINKS.TERMS}>
                                {TEXTS.TERMS}
                            </a>
                        </li>
                        <li className="lk-itm">
                            <a className="lk-anc" href={FOOTER_LINKS.EU_POLICY}>
                                {TEXTS.EU_POLICY}
                            </a>
                        </li>
                        <li className="lk-itm">
                            <a className="lk-anc" href={FOOTER_LINKS.RESPONSIBLE_DISCLOSURE}>
                                {TEXTS.RESPONSIBLE_DISCLOSURE}
                            </a>
                        </li>
                    </ul>
                </div>

                <ResponsiveLoader breakpoint={BREAKPOINTS.TABLET_BIG} up>
                    <div className="lk-section ipad-hide">
                        <div className="lk-title">{TEXTS.QUICKLINKS}</div>
                        <ul className="lk-list">
                            <li className="lk-itm">
                                <a className="lk-anc" href={FOOTER_LINKS.OFFERS}>
                                    {TEXTS.OFFERS}
                                </a>
                            </li>
                            <li className="lk-itm">
                                <a className="lk-anc" href={FOOTER_LINKS.SITEMAP}>
                                    {TEXTS.SITEMAP}
                                </a>
                            </li>
                        </ul>
                    </div>
                </ResponsiveLoader>

                <div className="lk-section">
                    <div className="lk-title">{TEXTS.FOLLOW_US}</div>
                    <div className="lk-social">
                        <a href={INSTA_LINK} aria-label="Instagram" rel="noopener" target="_blank">
                            <i className="lk-icon lk-insta" />
                        </a>
                        <a href={FB_LINK} aria-label="Facebook" rel="noopener" target="_blank">
                            <i className="lk-icon lk-fb" />
                        </a>
                    </div>
                </div>
            </div>
        </WithStyles>
    );
}

export default memo(Links);
